import { Injectable, EventEmitter } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PhoneInputService {
  phoneChange = new EventEmitter<string>();

  // No dependencies required for this service

  propagateChange(updatedNumber: string): void {
    this.phoneChange.emit(updatedNumber);
  }
}
